import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/sync/site/`,
  detail: (id) => `${BASE_URL}/api/v1/sync/site/${id}/`,
};

export const siteSyncListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);
export const siteSyncDetailLoad = (token, { id }) => api.DetailLoad(endpoints.detail, token, { id });
export const siteSyncUpdate = (token, data) => api.Update(endpoints.list, endpoints.detail, token, data);
export const siteSyncDelete = (token, data) => api.Delete(endpoints.detail, token, data);

export const siteSync = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Синхронизации',
    urls: {
      list: () => `/siteSync`,
      detail: (id) => `/siteSync/${id}`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'siteSync', siteSyncListLoad)
    },

    async detailLoad(payload, rootState) {
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'siteSync', siteSyncDetailLoad)
    },

    async update(payload, rootState) {
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'siteSync', siteSyncUpdate);
    },

    async delete(payload, rootState) {
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'siteSync', siteSyncDelete);
    },
  }),
}